import React from "react";
import { Route, Switch } from "react-router-dom";
import { CataloguePath } from "routes/createContent/paths";
import { TemplateEditorPage } from "./TemplateEditorPage";
import { Templates } from "./Templates";
import { CatalogueChangesPage } from "routes/createContent/components/CatalogueChangesPage";

export const TemplateRoutes: React.VFC = () => (
  <Switch>
    <Route path={CataloguePath.Templates_New}>
      <TemplateEditorPage />
    </Route>
    <Route path={CataloguePath.Templates_Changes}>
      <CatalogueChangesPage kind="template" backTo={CataloguePath.Templates} />
    </Route>
    <Route path={CataloguePath.Templates_Edit}>
      <TemplateEditorPage />
    </Route>
    <Route path={`${CataloguePath.Templates}/:id`}>
      <TemplateEditorPage />
    </Route>
    <Route path={CataloguePath.Templates}>
      <Templates />
    </Route>
  </Switch>
);
